module.exports = __webpack_public_path__ + "img/collection-engagementRingsCollectionRings@2x.1965d04.webp";